<div *ngIf="contenido">
  <div class="contenedor-separador">
    <app-skeleton-image [customClass]="'desktop-noticia-imagen'" [src]="contenido?.urlImagen" [lazy]="lcp" [alt]="contenido?.texto" [width]="980" [height]="95" [size]="980" [aspectRatio]="980 / 95" [isFill]="true"> </app-skeleton-image>
  </div>
</div>
